<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link :to="{name: 'Create Payroll'}" class="button is-small is-info">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create (single payroll)</router-link>
        &nbsp;
        <router-link :to="{name: 'Create Bulk Payroll'}" class="button is-small is-info">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create (bulk payroll)</router-link>
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <span v-show="selectedPayrollIds.length!=0">
          &nbsp;
          <button :class="buttonSendToMultipleEmails" @click="sendToMultipleEmails">Send multiple emails ({{selectedPayrollIds.length}})</button>
          &nbsp;
          <button class="button is-small is-danger" @click="openDeleteMultiplePayrollModal">Delete multiple payrolls ({{selectedPayrollIds.length}})</button>
          &nbsp;
          <button @click="deselectSelectedPayrollIds" class="button is-small is-inverted">Deselect</button>
        </span>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Payroll from</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="sortByPayrollFrom" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Payroll to</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="sortByPayrollTo" />
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <button :class="buttonDownloadReportPeriodPdf" v-show="sortByPayrollFrom && sortByPayrollTo != null" @click="downloadPayrollReportPeriod">Download Report</button>
            &nbsp;
            <button :class="buttonDownloadReportPeriodPdf" v-show="sortByPayrollFrom && sortByPayrollTo != null" @click="downloadPayrollDescriptiveReportPeriod">Download Descriptive Report</button>
            &nbsp;
            <button class="button is-small" v-show="sortByPayrollFrom && sortByPayrollTo != null" @click="clearPayrollPeriod">Clear date period</button>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
      <div class="level-right">
        <b-switch size="is-small" v-model="selectAll">Select current data in list</b-switch>
      </div>
    </div>
    <table-pagination :tableData="payrolls.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="payrolls.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column field="payrollId" class="table-column-content-is-small" label="Payroll ID" sortable>
          {{item.row.payrollId}}
        </b-table-column>
        <b-table-column field="payrollId" class="table-column-content-is-small" label="Employee" sortable>
          {{item.row.employeeName}}
        </b-table-column>
        <b-table-column field="payrollFrom" class="table-column-content-is-small" label="Payroll From" sortable>
          {{item.row.payrollFrom}}
        </b-table-column>
        <b-table-column field="payrollTo" class="table-column-content-is-small" label="Payroll To" sortable>
          {{item.row.payrollTo}}
        </b-table-column>
        <b-table-column field="payrollDate" class="table-column-content-is-small" label="Payroll Date" sortable>
          {{item.row.payrollDate}}
        </b-table-column>
        <b-table-column field="netBasic" class="table-column-content-is-small" label="Net Basic">
          {{item.row.netBasic}}
        </b-table-column>
        <b-table-column field="totalDeduction" class="table-column-content-is-small" label="Total Deduction">
          {{item.row.totalDeduction}}
        </b-table-column>
        <b-table-column field="netPay" class="table-column-content-is-small" label="Net Pay">
          {{item.row.netPay}}
        </b-table-column>
        <b-table-column field="" class="table-column-content-is-small" label="Multiple select">
          <center><input type="checkbox" class="is-small" v-model="selectedPayrollIds" :value="{payrollId: item.row.payrollId}" /></center>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <router-link :to="{name: 'Edit Payroll', params: {'payrollId': item.row.payrollId}}" class="button is-warning is-small">Edit</router-link>&nbsp;
          <button :class="buttonDownloadPdf" @click="downloadPayslip(item.row.payrollId, item.row.employeeName, item.row.payrollDate)">Download PDF</button>&nbsp;
          <button :class="buttonSendToSingleEmail" @click="sendPayslipToEmail(item.row.payrollId)">Send to Email</button>&nbsp;
          <button class="button is-danger is-small" @click="deleteModal(item.row.payrollId)">Delete</button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </table-pagination>
    <delete />
  </div>
</template>

<script>
import TablePagination from '../TablePagination.vue'
import Delete from './Delete.vue'
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      selectAll: false,
      isEmpty: false,
      page: 1,
      perPage: 10,
      search: '',
      selectedPayrollIds: [],
      sortByPayrollFrom: null,
      sortByPayrollTo: null,
      buttonDownloadPdf: appButton.isLoadingNormal(false),
      buttonDownloadReportPeriodPdf: appButton.isLoadingNormal(false),
      buttonSendToSingleEmail: appButton.isLoadingNormal(false),
      buttonSendToMultipleEmails: appButton.isLoadingNormal(false)
    }
  },
  created() {
    this.checkIfRouteHasChanged()
  },
  computed: {
    ...mapState('payroll', {
      isLoadingTable: state => state.isLoadingTable,
      payrolls: state => state.payrolls
    })
  },
  mounted() {
    this.default()
  },
  components: {
    tablePagination: TablePagination,
    Delete
  },
  methods: {
    ...mapActions('payroll', ['getPaginatedPayrolls', 'openDeleteModal']),
    checkIfRouteHasChanged() {
      const dateFrom = this.$route.params.dateFrom
      const dateTo = this.$route.params.dateTo
      if ((dateFrom, dateTo)) {
        this.getPaginatedPayrolls({
          page: this.page,
          pageSize: this.perPage,
          query: this.search,
          payrollFrom: dateFrom,
          payrollTo: dateTo
        })
      }
    },
    refreshTable() {
      this.default()
    },
    default() {
      this.sortByPayrollFrom = null
      this.sortByPayrollTo = null
      this.$router.push({ name: 'List Of Payrolls' })

      this.getPaginatedPayrolls({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        payrollFrom: this.sortByPayrollFrom,
        payrollTo: this.sortByPayrollTo
      })
    },
    deleteModal(payrollId) {
      this.openDeleteModal({
        showDeleteModal: true,
        payroll: {
          payrollId: payrollId
        }
      })
    },
    openDeleteMultiplePayrollModal() {
      this.openDeleteModal({
        showDeleteModal: true,
        payroll: {
          payrollIds: this.selectedPayrollIds
        }
      })
    },
    downloadPayslip(id, name, payrollDate) {
      this.buttonDownloadPdf = appButton.isLoadingNormal(true)
      axios
        .post(`downloadables/payslip?id=${id}&isPdfFile=true`, [], {
          responseType: 'blob'
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${name}-${payrollDate}.pdf`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadPdf = appButton.isLoadingNormal(false)
        })
    },
    downloadPayrollReportPeriod() {
      this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(true)
      axios
        .get(
          `downloadables/payrollreportbyperiod?dateFrom=${
            this.sortByPayrollFrom
          }&dateTo=${this.sortByPayrollTo}`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `Payroll Period ${this.sortByPayrollFrom}-${
              this.sortByPayrollTo
            }.pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(false)
        })
    },
    downloadPayrollDescriptiveReportPeriod() {
      this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(true)
      axios
        .get(
          `downloadables/PayrollDescriptiveReportByPeriod?dateFrom=${
            this.sortByPayrollFrom
          }&dateTo=${this.sortByPayrollTo}`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `Descriptive Payroll Report by Period ${this.sortByPayrollFrom}-${
              this.sortByPayrollTo
            }.pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(false)
        })
    },
    sendToMultipleEmails() {
      this.buttonSendToMultipleEmails = appButton.isLoadingNormal(true)
      axios
        .post(
          `downloadables/payslip?id=0&isPdfFile=true&isSendToSingleEmail=false`,
          this.selectedPayrollIds
        )
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonSendToMultipleEmails = appButton.isLoadingNormal(false)
        })
    },
    sendPayslipToEmail(id) {
      // [] for empty
      this.buttonSendToSingleEmail = appButton.isLoadingNormal(true)
      axios
        .post(
          `downloadables/payslip?id=${id}&isPdfFile=true&isSendToSingleEmail=true`,
          []
        )
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonSendToSingleEmail = appButton.isLoadingNormal(false)
        })
    },
    sortByPayrollPeriod() {
      if ((this.sortByPayrollFrom, this.sortByPayrollTo)) {
        this.$router.push({
          name: 'Sort by Payroll Period',
          params: {
            dateFrom: this.sortByPayrollFrom,
            dateTo: this.sortByPayrollTo
          }
        })
      }
    },
    clearPayrollPeriod() {
      this.refreshTable()
    },
    selectAllPayrollInCurrentTable() {
      this.payrolls.data.forEach(payroll => {
        this.selectedPayrollIds = [
          ...this.selectedPayrollIds,
          {
            payrollId: payroll.payrollId
          }
        ]
      })
    },
    deselectSelectedPayrollIds() {
      this.selectAll = false
      this.selectedPayrollIds = []
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedPayrolls({
        page: this.page,
        pageSize: val,
        query: this.search,
        payrollFrom: this.sortByPayrollFrom,
        payrollTo: this.sortByPayrollTo
      })
    },
    page(val) {
      this.getPaginatedPayrolls({
        page: val,
        pageSize: this.perPage,
        query: this.search,
        payrollFrom: this.sortByPayrollFrom,
        payrollTo: this.sortByPayrollTo
      })
    },
    search(val) {
      this.getPaginatedPayrolls({
        page: this.page,
        pageSize: this.perPage,
        query: val,
        payrollFrom: this.sortByPayrollFrom,
        payrollTo: this.sortByPayrollTo
      })
    },
    selectedPayrollIds() {
      if (this.selectedPayrollIds) {
      }
    },
    $route(to, from) {
      // if route has change
      this.checkIfRouteHasChanged()
    },
    sortByPayrollFrom() {
      this.sortByPayrollPeriod()
    },
    sortByPayrollTo() {
      this.sortByPayrollPeriod()
    },
    isLoadingTable() {
      if (this.isLoadingTable) {
        this.deselectSelectedPayrollIds()
        this.selectAll = false
      }
    },
    selectAll() {
      if (this.selectAll) {
        this.selectAllPayrollInCurrentTable()
      } else {
        this.deselectSelectedPayrollIds()
      }
    }
  }
}
</script>
